import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { useUser } from '../../context/UserContext';
import { submitForm, getFormByUserId, updateForm } from '../../api/formApi';
import { Modal, Button } from 'react-bootstrap';
import { API_BASE_URL } from '../dashboardContent/config'; 
import '../../StylesCSS/FormInformation.css';


const Form = () => {
  const [nom, setNom] = useState('');
  const [secteur, setSecteur] = useState('');
  const [institutions, setInstitutions] = useState(['']);
  const [annee, setAnnee] = useState('');
  const [direction_provinciale, setDirectionProvinciale] = useState('');
  const [direction_régionale, setDirectionRégionale] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalColor, setModalColor] = useState('green');
  const [isEdit, setIsEdit] = useState(false);  // Pour gérer l'état de modification
  const [formExists, setFormExists] = useState(false); // Pour savoir si un formulaire existe déjà
  

  const { userId } = useUser();
  
  const [directions, setDirections] = useState({ direction_provinciale: '', direction_regionale: '' });
  const [loading, setLoading] = useState(true);


   useEffect(() => {
    if (userId) {
      axios.get(`${API_BASE_URL}/api/forms/directions/${userId}`)
        .then(response => {
          console.log('Direction provinciale :', response.data.direction_provinciale);
          console.log('Direction régionale :', response.data.direction_regionale);
          setDirections(response.data);
          setLoading(false);
        })
        .catch(error => {
          console.error('Erreur lors du chargement des directions:', error);
          setLoading(false);
        });
    }
  }, [userId]);

  useEffect(() => {
    const fetchFormData = async () => {
      if (userId) {
        try {
          const formData = await getFormByUserId(userId);
          const institutionNames = Array.isArray(formData?.institutions)
            ? formData.institutions
                .map((institution) => (
                  typeof institution === 'string'
                    ? institution
                    : institution?.name || institution?.institution || institution?.nom || ''
                ))
                .filter(Boolean)
            : [];
          if (formData) {
            setNom(formData.nom);
            setSecteur(formData.secteur);
            setInstitutions(institutionNames.length > 0 ? institutionNames : ['']);
            setAnnee(formData.annee);
            setDirectionProvinciale(formData.direction_provinciale);
            setDirectionRégionale(formData.direction_régionale);
            setFormExists(true);  // Indique qu'un formulaire existe
          }
        } catch (error) {
          console.error(error);
          setModalMessage('يرجى إدخال المعلومات الشخصية قبل المتابعة.');
          setModalColor('red');
          setShowModal(true);
        }
      }
    };

    fetchFormData();
  }, [userId]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!nom || !secteur || institutions.some(inst => !inst) || !annee || !direction_provinciale || !direction_régionale) {
      setModalMessage('يجب ملء جميع الخانات');
      setModalColor('red');
      setShowModal(true);
      return;
    }

    if (!userId) {
      setModalMessage('Utilisateur non connecté.');
      setModalColor('red');
      setShowModal(true);
      return;
    }

    try {
      const formData = {
        nom,
        secteur,
        institutions: institutions.map(name => ({ name, user: { id: userId } })),
        annee,
        direction_provinciale,
        direction_régionale,
        user: { id: userId }
      };

      if (formExists) {
        console.log("formdata update", formData);

        await updateForm(userId ,formData);  // Mettre à jour le formulaire existant
        console.log("formdata update", formData);
        setModalMessage('تم تعديل البيانات بنجاح.');
      } else {
        await submitForm(formData);  // Soumettre un nouveau formulaire
        setModalMessage('تم تسجيل البيانات بنجاح.');
        setFormExists(true);
      }

      setModalColor('green');
      setShowModal(true);
      setIsEdit(false);
    } catch (error) {
      console.error(error);
      setModalMessage('Erreur lors de l\'envoi du formulaire.');
      setModalColor('red');
      setShowModal(true);
    }
  };

  const handleEditClick = () => {
    setIsEdit(true);  // Activer le mode modification
    setShowModal(true);  // Afficher le modal
  };

  const handleAddInstitution = () => {
    setInstitutions([...institutions, '']);
  };

  const handleRemoveInstitution = (index) => {
    const newInstitutions = institutions.filter((_, i) => i !== index);
    setInstitutions(newInstitutions);
  };

  const handleInstitutionChange = (index, value) => {
    const newInstitutions = [...institutions];
    newInstitutions[index] = value;
    setInstitutions(newInstitutions);
  };

  return (
    <div className="form-information-page" dir="rtl">
      <div className="form-information-header">
        <span className="form-information-kicker">البيانات الأساسية</span>
        <h2>المعلومات</h2>
        <p>يرجى إدخال المعلومات الإدارية الخاصة بكم وبالمؤسسة.</p>
      </div>
      {!formExists ? (
        <form onSubmit={handleSubmit} className="information-form">
          <div className="information-field form-group">
            <label htmlFor="nom">الاسم :</label>
            <input
              type="text"
              className="form-control"
              id="nom"
              value={nom}
              onChange={(e) => setNom(e.target.value)}
              style={{ width: '100%' }}
              required
            />
          </div>
          <div className="information-field form-group">
            <label htmlFor="secteur">القطاع :</label>
            <input
              type="text"
              className="form-control"
              id="secteur"
              value={secteur}
              onChange={(e) => setSecteur(e.target.value)}
              style={{ width: '100%' }}
              required
            />
          </div>
          <div className="information-field form-group institution-field">
            <label>المؤسسات :</label>
            <small>أضف المؤسسات التابعة لهذا الحساب.</small>
            {institutions.map((institution, index) => (
              <div key={index} className="institution-row">
                <input
                  type="text"
                  value={institution}
                  onChange={(e) => handleInstitutionChange(index, e.target.value)}
                  className="form-control institution-input"
                  required
                />
                {index === institutions.length - 1 && (
                  <button
                    type="button"
                    onClick={handleAddInstitution}
                    className="btn btn-secondary"
                    style={{ marginRight: '5px' }}
                  >
                    +
                  </button>
                )}
                {institutions.length > 1 && (
                  <button
                    type="button"
                    onClick={() => handleRemoveInstitution(index)}
                    className="btn btn-danger"
                  >
                    -
                  </button>
                )}
              </div>
            ))}
          </div>
          <div className="information-field form-group">
            <label htmlFor="annee">السنة الدراسية :</label>
            <input
              type="text"
              className="form-control"
              id="annee"
              value={annee}
              onChange={(e) => setAnnee(e.target.value)}
              style={{ width: '100%' }}
              required
            />
          </div>
          <div className="information-field form-group">
            <label htmlFor="direction_provinciale">المديرية الاقليمية :</label>
            <input
              type="text"
              className="form-control"
              id="direction_provinciale"
              value={direction_provinciale}
              onChange={(e) => setDirectionProvinciale(e.target.value)}
              style={{ width: '100%' }}
              required
            />
          </div>
          <div className="information-field form-group">
            <label htmlFor="direction_régionale">الأكاديمية الجهوية :</label>
            <input
              type="text"
              className="form-control"
              id="direction_régionale"
              value={direction_régionale}
              onChange={(e) => setDirectionRégionale(e.target.value)}
              style={{ width: '100%' }}
              required
            />
          </div>
          <div className="information-actions">
            <button type="submit" className="btn btn-primary information-submit">تسجيل</button>
          </div>
        </form>
      ) : (
        <>
 <div className="information-details-card">
      <div className="details-heading">
        <span className="form-information-kicker">ملخص الحساب</span>
        <h2>تفاصيل المعلومات</h2>
        <p>راجع البيانات المسجلة قبل تعديلها.</p>
      </div>
      <div className="details-grid">
        <div className="detail-item">
          <strong>الاسم :</strong><span>{nom}</span>
        </div>
        <div className="detail-item">
          <strong>القطاع :</strong><span>{secteur}</span>
        </div>
        <div className="detail-item detail-item-wide">
          <strong>المؤسسات :</strong><span>{institutions.join(', ')}</span>
        </div>
        <div className="detail-item">
          <strong>السنة الدراسية :</strong><span>{annee}</span>
        </div>
        <div className="detail-item">
          <strong>المديرية الاقليمية :</strong><span>{direction_provinciale}</span>
        </div>
        <div className="detail-item detail-item-wide">
          <strong>الأكاديمية الجهوية :</strong><span>{direction_régionale}</span>
        </div>
      </div>
      <div className="information-actions">
        <button onClick={handleEditClick} className="information-edit-button">
          تعديل
        </button>
      </div>
    </div>
        </>
      )}

      {/* Modal pour modification */}
      <Modal show={isEdit} onHide={() => setIsEdit(false)}>
        <Modal.Header closeButton>
          <Modal.Title>تعديل المعلومات</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <div className="form-group" style={{ marginBottom: '15px' }}>
              <label htmlFor="nom" style={{ display: 'block', textAlign: 'right' }}>الاسم :</label>
              <input
                type="text"
                className="form-control"
                id="nom"
                value={nom}
                onChange={(e) => setNom(e.target.value)}
                style={{ width: '100%' }}
                required
              />
            </div>
            <div className="form-group" style={{ marginBottom: '15px' }}>
              <label htmlFor="secteur" style={{ display: 'block', textAlign: 'right' }}>القطاع :</label>
              <input
                type="text"
                className="form-control"
                id="secteur"
                value={secteur}
                onChange={(e) => setSecteur(e.target.value)}
                style={{ width: '100%' }}
                required
              />
            </div>
            <div className="form-group" style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', textAlign: 'right' }}>المؤسسات :</label>
              {institutions.map((institution, index) => (
                <div key={index} style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                  <input
                    type="text"
                    className="form-control"
                    value={institution}
                    onChange={(e) => handleInstitutionChange(index, e.target.value)}
                    style={{ flex: 1, marginRight: '10px' }}
                    required
                  />
                  {index === institutions.length - 1 && (
                    <button
                      type="button"
                      onClick={handleAddInstitution}
                      className="btn btn-secondary"
                      style={{ marginRight: '5px' }}
                    >
                      +
                    </button>
                  )}
                  {institutions.length > 1 && (
                    <button
                      type="button"
                      onClick={() => handleRemoveInstitution(index)}
                      className="btn btn-danger"
                    >
                      -
                    </button>
                  )}
                </div>
              ))}
            </div>
            <div className="form-group" style={{ marginBottom: '15px' }}>
              <label htmlFor="annee" style={{ display: 'block', textAlign: 'right' }}>السنة الدراسية :</label>
              <input
                type="text"
                className="form-control"
                id="annee"
                value={annee}
                onChange={(e) => setAnnee(e.target.value)}
                style={{ width: '100%' }}
                required
              />
            </div>
            <div className="form-group" style={{ marginBottom: '15px' }}>
              <label htmlFor="direction_provinciale" style={{ display: 'block', textAlign: 'right' }}>المديرية الاقليمية :</label>
              <input
                type="text"
                className="form-control"
                id="direction_provinciale"
                value={direction_provinciale}
                onChange={(e) => setDirectionProvinciale(e.target.value)}
                style={{ width: '100%' }}
                required
              />
            </div>
            <div className="form-group" style={{ marginBottom: '15px' }}>
              <label htmlFor="direction_régionale" style={{ display: 'block', textAlign: 'right' }}>الأكاديمية الجهوية :</label>
              <input
                type="text"
                className="form-control"
                id="direction_régionale"
                value={direction_régionale}
                onChange={(e) => setDirectionRégionale(e.target.value)}
                style={{ width: '100%' }}
                required
              />
            </div>
            <div style={{ textAlign: 'center' }}>
              <button type="submit" className="btn btn-primary">تحديث</button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      {/* Modal pour messages de confirmation */}
      <Modal show={!!modalMessage} onHide={() => setModalMessage('')} centered backdrop="static">
        <Modal.Header
          style={{
            borderBottom: 'none',
            background: '#f8fafc',
            direction: 'rtl',
            padding: '0.8rem 1rem 0.5rem 1rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', direction: 'rtl' }}>
            <button
              type="button"
              onClick={() => setModalMessage('')}
              aria-label="Close"
              style={{
                width: '30px',
                height: '30px',
                marginTop: '-3px',
                border: 'none',
                borderRadius: '8px',
                background: '#dbeafe',
                color: '#1d4ed8',
                fontSize: '1.2rem',
                fontWeight: 700,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 6px rgba(29,78,216,0.15)'
              }}
            >
              ×
            </button>
            <Modal.Title style={{ color: '#1f2937', fontWeight: 700, fontSize: '1.1rem', margin: 0 }}>معلومة</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body style={{
          textAlign: 'center',
          color: modalColor === 'green' ? '#0f766e' : '#b91c1c',
          background: '#ffffff',
          padding: '1rem 1.5rem 1.2rem 1.5rem',
          borderRadius: '0 0 12px 12px',
          fontSize: '1.05rem',
          lineHeight: 1.8,
          fontWeight: 600
        }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', flexWrap: 'wrap' }}>
            <span>{modalMessage}</span>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ borderTop: 'none', justifyContent: 'center', paddingTop: 0, paddingBottom: '1rem' }}>
          <Button
            onClick={() => setModalMessage('')}
            style={{
              minWidth: '150px',
              borderRadius: '10px',
              border: 'none',
              background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
              color: '#fff',
              fontWeight: 700,
              boxShadow: '0 8px 18px rgba(220, 38, 38, 0.25)',
              padding: '0.7rem 1.2rem'
            }}
          >
            إغلاق
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Form;
